import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import { storableError } from '../../util/errors';
import { createImageVariantConfig } from '../../util/sdkLoader';
import { addMarketplaceEntities } from '../../ducks/marketplaceData.duck';

const NEWEST_LISTINGS_COUNT = 4;

const queryNewestListingsPayloadCreator = (config, thunkAPI) => {
  const { dispatch, extra: sdk, rejectWithValue } = thunkAPI;
  const {
    aspectWidth = 1,
    aspectHeight = 1,
    variantPrefix = 'listing-card',
  } = config.layout.listingImage;
  const aspectRatio = aspectHeight / aspectWidth;

  return sdk.listings
    .query({
      perPage: NEWEST_LISTINGS_COUNT,
      page: 1,
      include: ['images', 'author'],
      'fields.image': [`variants.${variantPrefix}`, `variants.${variantPrefix}-2x`],
      ...createImageVariantConfig(`${variantPrefix}`, 400, aspectRatio),
      ...createImageVariantConfig(`${variantPrefix}-2x`, 800, aspectRatio),
      'limit.images': 1,
    })
    .then(response => {
      dispatch(addMarketplaceEntities(response));
      return response.data.data.map(listing => listing.id);
    })
    .catch(e => {
      return rejectWithValue(storableError(e));
    });
};

export const queryNewestListingsThunk = createAsyncThunk(
  'app/LandingPage/queryNewestListings',
  queryNewestListingsPayloadCreator
);

const initialState = {
  newestListingIds: [],
  queryListingsInProgress: false,
  queryListingsError: null,
};

const landingPageSlice = createSlice({
  name: 'LandingPage',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(queryNewestListingsThunk.pending, state => {
        state.queryListingsInProgress = true;
        state.queryListingsError = null;
      })
      .addCase(queryNewestListingsThunk.fulfilled, (state, action) => {
        state.newestListingIds = action.payload;
        state.queryListingsInProgress = false;
      })
      .addCase(queryNewestListingsThunk.rejected, (state, action) => {
        state.queryListingsInProgress = false;
        state.queryListingsError = action.payload;
      });
  },
});

export default landingPageSlice.reducer;

export const loadData = (params, search, config) => dispatch => {
  return dispatch(queryNewestListingsThunk(config));
};
